function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigaAppLfgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 463.05 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 0.2,
    width: 81.6,
    height: 169.9,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M228.4,169.5c-1.7-.6-39.7-15.8-58.3-63.7-1.7-3.8-3.1-7.9-4.3-12.1-2.2-7.9-3.2-16.4-3.2-25.2s1.7-19.5,4.9-30c3.1-10.3,8.3-20.7,15.3-31.2l4.9-7.3,6.2,6.1c1.6,1.6,3.3,2.8,5.3,3.7,2.3,1.1,4.7,1.9,7.1,2.2.4,0,.9.1,1.4.1h2.5c2.7-.1,5.5-.8,8.2-2,2.6-1.1,5-2.6,6.9-4.4l4.9-4.5,4.9,4.5c2,1.8,4.3,3.3,6.9,4.4,2.7,1.1,5.5,1.9,8.4,2h2.3c.5,0,1,0,1.5-.1,2.3-.3,4.7-1,7-2.2,2-.9,3.7-2.2,5.3-3.7L272.7,0l4.9,7.3c6.8,10,11.8,20.1,14.9,29.9h0l.3,1.1c3.2,10.5,4.9,20.6,4.9,30s-1,17.3-3.2,25.2c-1.1,4.2-2.5,8.2-4.3,12.1-18.7,47.9-56.8,63.1-58.3,63.7l-1.8.7-1.8-.7h.3l-.2.2Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,164.5c-2.8-1.1-37.7-15.8-55.2-60.6-1.7-3.8-3-7.6-4.1-11.5-2-7.5-3-15.5-3-23.8s1.6-18.5,4.7-28.5c3-9.8,7.9-19.8,14.7-29.7l1.4-2,1.7,1.7c2,2,4.3,3.5,6.8,4.7,2.8,1.4,5.7,2.2,8.5,2.6.6,0,1.1.1,1.8.2h2.9c3.6-.2,7-1,10.3-2.4,3.2-1.4,6-3.2,8.4-5.4l1.4-1.2,1.4,1.2c2.4,2.2,5.2,4.1,8.4,5.4,3.3,1.5,6.8,2.3,10.2,2.4h3c.6,0,1.2,0,1.8-.2,2.9-.4,5.7-1.4,8.5-2.6,2.5-1.1,4.8-2.8,6.8-4.7l1.7-1.7,1.4,2c6.4,9.6,11.2,19.2,14.2,28.7l.3,1.1c3.1,10,4.6,19.5,4.6,28.5s-1,16.3-3,23.8c-1,3.8-2.4,7.7-4,11.3-17.6,45-52.5,59.8-55.3,60.8h0l-.3-.1Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,84.1c-2.3,9.6-12,15.5-21.5,13.2-9.6-2.3-15.5-12-13.2-21.5,2.3-9.6,12-15.5,21.5-13.2,1.9.4,3.5,1.1,5.1,2.1l10.2-6.2c-3.5-3.1-7.8-5.5-12.7-6.7-15.6-3.7-31.3,5.9-34.9,21.4-3.7,15.6,5.9,31.3,21.4,34.9,15.6,3.7,31.3-5.9,34.9-21.4,1.1-4.8,1-9.6-.1-14l-10.3,6.3c0,1.7,0,3.3-.4,5.1h0Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,61.4l-9.7,5.9c2.1,2.1,3.5,4.6,4.4,7.4l9.8-5.9c-1.1-2.6-2.6-5.1-4.5-7.3h0v-.1Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,64.9h0c-.9-.3-1.9-.5-2.7-.7s-.4,0-.6-.1l-6.3,4c2.2,6.5,2.7,13.7.9,21-4.9,20.4-25.5,33.1-45.9,28.2s-33.1-25.5-28.2-45.8c4.9-20.4,25.5-33.1,45.9-28.2,7.3,1.8,13.6,5.5,18.5,10.6l6.4-4c.3-1.1.5-2.3.7-3.4,0-.3.1-.7.2-1-6.2-6.2-14.1-10.8-23.3-13-26.4-6.3-53,10-59.4,36.4-6.3,26.4,10,53,36.4,59.4,26.4,6.3,53-10,59.4-36.4,2.2-9,1.7-18.1-.9-26.3-.4,0-.7-.2-1.1-.3v-.4Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,60.2c.4,0,.8.2,1.2.3-1.8-4.2-4.2-8-7.1-11.5-.2,1.1-.5,2.3-.9,3.4l-7.2,4.5c1.8,2.3,3.2,4.7,4.5,7.3l7.1-4.4c.7.1,1.6.3,2.4.5h0v-.1Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,45.3c-.2-.9-.7-1.7-1.7-1.9l-13.4-3.2,3.2-13.4c.2-.9-.3-2.1-1.4-2.6-.9-.5-2-.5-2.7.1l-21.6,13.3h-.1c-1.2.9-2.1,2.2-2.6,3.5-.6,1.9-1,3.8-1.5,5.8-.3,1.8-.7,3.6-1.2,5.3l-38.6,23.7-.2.2c-1.7,1.5-2.1,3.8-.9,5.6.6,1,1.6,1.7,2.6,1.9.8.2,1.8.1,2.7-.2l38.9-23.8c1.8.3,3.5.7,5.2,1.2,1.8.5,3.6,1,5.5,1.2,1.9.3,3.4,0,5-.7l21.7-13.4c.9-.6,1.2-1.8,1-2.6h.1Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.4,169.5c-1.7-.6-39.7-15.8-58.3-63.7-1.7-3.8-3.1-7.9-4.3-12.1-2.2-7.9-3.2-16.4-3.2-25.2s1.7-19.5,4.9-30c3.1-10.3,8.3-20.7,15.3-31.2l4.9-7.3,6.2,6.1c1.6,1.6,3.3,2.8,5.3,3.7,2.3,1.1,4.7,1.9,7.1,2.2.4,0,.9.1,1.4.1h2.5c2.7-.1,5.5-.8,8.2-2,2.6-1.1,5-2.6,6.9-4.4l4.9-4.5,4.9,4.5c2,1.8,4.3,3.3,6.9,4.4,2.7,1.1,5.5,1.9,8.4,2h2.3c.5,0,1,0,1.5-.1,2.3-.3,4.7-1,7-2.2,2-.9,3.7-2.2,5.3-3.7L272.7,0l4.9,7.3c6.8,10,11.8,20.1,14.9,29.9h0l.3,1.1c3.2,10.5,4.9,20.6,4.9,30s-1,17.3-3.2,25.2c-1.1,4.2-2.5,8.2-4.3,12.1-18.7,47.9-56.8,63.1-58.3,63.7l-1.8.7-1.8-.7h.3l-.2.2Z",
    style: {
      fill: "#c00418"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,164.5c-2.8-1.1-37.7-15.8-55.2-60.6-1.7-3.8-3-7.6-4.1-11.5-2-7.5-3-15.5-3-23.8s1.6-18.5,4.7-28.5c3-9.8,7.9-19.8,14.7-29.7l1.4-2,1.7,1.7c2,2,4.3,3.5,6.8,4.7,2.8,1.4,5.7,2.2,8.5,2.6.6,0,1.1.1,1.8.2h2.9c3.6-.2,7-1,10.3-2.4,3.2-1.4,6-3.2,8.4-5.4l1.4-1.2,1.4,1.2c2.4,2.2,5.2,4.1,8.4,5.4,3.3,1.5,6.8,2.3,10.2,2.4h3c.6,0,1.2,0,1.8-.2,2.9-.4,5.7-1.4,8.5-2.6,2.5-1.1,4.8-2.8,6.8-4.7l1.7-1.7,1.4,2c6.4,9.6,11.2,19.2,14.2,28.7l.3,1.1c3.1,10,4.6,19.5,4.6,28.5s-1,16.3-3,23.8c-1,3.8-2.4,7.7-4,11.3-17.6,45-52.5,59.8-55.3,60.8h0l-.3-.1Z",
    style: {
      fill: "#cbc0a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,84.1c-2.3,9.6-12,15.5-21.5,13.2-9.6-2.3-15.5-12-13.2-21.5,2.3-9.6,12-15.5,21.5-13.2,1.9.4,3.5,1.1,5.1,2.1l10.2-6.2c-3.5-3.1-7.8-5.5-12.7-6.7-15.6-3.7-31.3,5.9-34.9,21.4-3.7,15.6,5.9,31.3,21.4,34.9,15.6,3.7,31.3-5.9,34.9-21.4,1.1-4.8,1-9.6-.1-14l-10.3,6.3c0,1.7,0,3.3-.4,5.1h0Z",
    style: {
      fill: "#c00418"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,61.4l-9.7,5.9c2.1,2.1,3.5,4.6,4.4,7.4l9.8-5.9c-1.1-2.6-2.6-5.1-4.5-7.3h0v-.1Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,64.9h0c-.9-.3-1.9-.5-2.7-.7s-.4,0-.6-.1l-6.3,4c2.2,6.5,2.7,13.7.9,21-4.9,20.4-25.5,33.1-45.9,28.2s-33.1-25.5-28.2-45.8c4.9-20.4,25.5-33.1,45.9-28.2,7.3,1.8,13.6,5.5,18.5,10.6l6.4-4c.3-1.1.5-2.3.7-3.4,0-.3.1-.7.2-1-6.2-6.2-14.1-10.8-23.3-13-26.4-6.3-53,10-59.4,36.4-6.3,26.4,10,53,36.4,59.4,26.4,6.3,53-10,59.4-36.4,2.2-9,1.7-18.1-.9-26.3-.4,0-.7-.2-1.1-.3v-.4Z",
    style: {
      fill: "#c00418"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,60.2c.4,0,.8.2,1.2.3-1.8-4.2-4.2-8-7.1-11.5-.2,1.1-.5,2.3-.9,3.4l-7.2,4.5c1.8,2.3,3.2,4.7,4.5,7.3l7.1-4.4c.7.1,1.6.3,2.4.5h0v-.1Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,45.3c-.2-.9-.7-1.7-1.7-1.9l-13.4-3.2,3.2-13.4c.2-.9-.3-2.1-1.4-2.6-.9-.5-2-.5-2.7.1l-21.6,13.3h-.1c-1.2.9-2.1,2.2-2.6,3.5-.6,1.9-1,3.8-1.5,5.8-.3,1.8-.7,3.6-1.2,5.3l-38.6,23.7-.2.2c-1.7,1.5-2.1,3.8-.9,5.6.6,1,1.6,1.7,2.6,1.9.8.2,1.8.1,2.7-.2l38.9-23.8c1.8.3,3.5.7,5.2,1.2,1.8.5,3.6,1,5.5,1.2,1.9.3,3.4,0,5-.7l21.7-13.4c.9-.6,1.2-1.8,1-2.6h.1Z",
    style: {
      fill: "#c00418"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path68660"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.1,152.7v-56.1c31.6-6,63-14.2,93.8-24.5-10.4,12.9-20.9,25.5-31.5,37.8,10.5,6.3,21,12.5,31.5,18.3-30.8,10.4-62.2,18.5-93.8,24.5h0Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.4,74.6c-9.2,11.2-18.4,22.2-27.7,33.2-.7.9-1.6,1.9-2.3,2.7.7.5,1.6.9,2.3,1.5,9.3,5.6,18.4,10.9,27.7,16.1-29.2,9.7-58.9,17.4-88.9,23.1v-53.4c29.9-5.7,59.7-13.4,88.9-23.1M459.4,69.4c-32.4,11.1-65.4,19.8-98.8,26v58.9c33.4-6.2,66.3-15,98.8-26-10.9-6-21.9-12.5-33-19,11-13,22-26.3,33-39.8q4.87-6,0,0h0v-.1Z",
    style: {
      fill: "#efe1bc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect67025-5-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.1,96.2c14.9-8.6,29.7-17.7,44.5-27.3v55.9c-14.8,9.6-29.6,18.7-44.5,27.3,0,0,0-55.9,0-55.9Z",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,71.2v53c-13.8,8.9-27.8,17.5-41.8,25.6v-53c14-8.1,28-16.6,41.8-25.6M407.9,66.5c-15.7,10.2-31.4,19.9-47.3,29v58.9c15.8-9.1,31.6-18.8,47.3-29v-58.9h0Z",
    style: {
      fill: "#efe1bc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path67027-9-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,128.2c10.4-5.8,20.9-12,31.5-18.3-10.5-12.4-21-25-31.5-37.8,30.8,10.4,62.2,18.5,93.8,24.5v56.1c-31.6-6-63-14.2-93.8-24.5h0Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,97.7v53.4c-29.9-5.7-59.7-13.4-88.9-23.1,9.2-5.2,18.4-10.6,27.7-16.1.7-.5,1.6-.9,2.3-1.5-.7-.9-1.6-1.9-2.3-2.7-9.3-10.8-18.4-21.9-27.7-33.2,29.2,9.7,58.9,17.4,88.9,23.1M98.8,95.5c-33.4-6.2-66.3-15-98.8-26,10.9,13.5,21.9,26.8,33,39.8-11,6.7-22,13-33,19,32.4,11.1,65.4,19.8,98.8,26v-58.9h0v.1Z",
    style: {
      fill: "#efe1bc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect68626"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8,124.9v-55.9c14.8,9.6,29.6,18.7,44.5,27.3v55.9c-14.9-8.6-29.7-17.7-44.5-27.3Z",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2,71.2c13.8,8.9,27.8,17.5,41.8,25.6v53c-14-8.1-28-16.6-41.8-25.6v-53M51.5,66.5v58.9c15.7,10.2,31.4,19.9,47.3,29v-58.9c-15.8-9.1-31.6-18.8-47.3-29h0Z",
    style: {
      fill: "#efe1bc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path65659-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8,124.4v-56.1c116.1,29.8,237.7,29.8,353.8,0v56.1c-116.1,29.8-237.7,29.8-353.8,0h0Z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,70v53.4c-115.1,29.4-235.8,29.4-351.1,0v-53.4c115.1,29.4,235.8,29.4,351.1,0M407.9,66.5c-116.9,30.4-239.6,30.4-356.5,0v58.9c116.9,30.4,239.6,30.4,356.5,0v-58.9h0Z",
    style: {
      fill: "#efe1bc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67,82.6c2.5.6,4.9,1.1,7.4,1.7v26.7c2.6.6,5.3,1.1,7.9,1.8v7.8c-5.1-1-10.2-2.2-15.3-3.4v-34.6Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2,88.8v34.6c-2.5-.5-5-.9-7.4-1.5v-34.6c2.5.5,4.9.9,7.4,1.5Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.1,103.5v-3.1c-2.6-.4-5.3-.8-7.9-1.4v19.1c2.6.4,5.3.9,7.9,1.4v-4.9c-.9-.1-2-.3-2.9-.5v-6.5c3.4.5,6.9,1.1,10.4,1.7v12.8c0,3.4-2.7,5.9-6.1,5.4-3.5-.5-7.1-1.1-10.6-1.8-3.4-.6-6.1-4-6.1-7.5v-21.8c0-3.4,2.7-5.8,6.1-5.3,3.5.6,7.1,1.1,10.6,1.8,3.4.5,6.1,3.8,6.1,7.3v4.5c-2.5-.4-5-.7-7.5-1.1h0v-.1Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.1,132.3c-2.5-.2-5-.5-7.5-.8-.3-1.4-.6-2.6-1-4-3.1-.3-6.1-.7-9.3-1.1-.3,1.2-.6,2.5-1,3.6-2.5-.3-5-.6-7.5-1,3-11.1,5.9-22.2,8.9-33.4,2.8.3,5.5.7,8.3,1,3,11.9,5.9,23.7,8.9,35.6h.1l.1.1ZM147,121c-.9-4-2-7.9-2.9-11.9-1,3.7-2,7.5-3,11.2,2,.2,4,.5,5.9.7h0Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.4,106.9v6.5c2.8.2,5.5.4,8.3.6v6.4c-2.8-.2-5.5-.4-8.3-.6v13.8c-2.5-.2-5-.4-7.5-.6v-34.6c5.8.5,11.8,1,17.6,1.5v7.8c-3.3-.2-6.8-.5-10.1-.7h0v-.1Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,135.8c-2.5,0-5-.2-7.5-.2-.3-1.2-.6-2.6-1-3.8-3.1-.1-6.2-.3-9.4-.4-.3,1.2-.6,2.5-1,3.7-2.5-.1-5-.3-7.5-.4,3-11.3,6-22.7,8.9-34,2.8.1,5.6.3,8.4.4,3,11.6,6,23.3,8.9,34.9v-.2h.2ZM198.9,125.2c-.9-3.8-2-7.8-2.9-11.6-1,3.8-2,7.6-3,11.4,2,0,4,.2,5.9.3h0v-.1Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9,101.5v34.6h-7.6c-2.6-5.9-5.3-11.9-7.9-17.8v17.7c-2.5,0-5,0-7.5-.1v-34.6c2.5,0,5.1,0,7.6.1,2.6,5.9,5.3,11.9,7.9,17.8v-17.7h7.5Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,111.7v-3.1c-2.7.1-5.3.2-8,.3v19.1c2.7,0,5.3-.2,8-.3v-4.9c-.9,0-2,0-2.9.1v-6.5c3.5-.1,7-.3,10.5-.5v12.8c0,3.4-2.7,6.5-6.1,6.7-3.5.2-7.1.3-10.7.4-3.4.1-6.1-2.7-6.1-6.2v-21.8c0-3.4,2.7-6.4,6.1-6.5,3.5-.1,7.1-.2,10.7-.4,3.4-.2,6.1,2.6,6.1,6v4.5c-2.5.1-5,.3-7.5.4h-.1v-.1Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.2,132.5c-2.5.2-5,.5-7.5.7-.3-1.2-.6-2.5-1-3.7-3.1.3-6.2.5-9.3.7-.3,1.2-.6,2.6-1,3.8-2.5.2-5,.3-7.5.5,3-11.7,6-23.5,8.9-35.2,2.8-.2,5.6-.4,8.3-.7,3,11.2,5.9,22.6,8.9,33.8h.1l.1.1ZM290,123.3c-.9-3.7-2-7.5-2.9-11.3-1,4-2,7.9-3,11.7,2-.1,4-.3,5.9-.5h0v.1Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,93.3v34.6c-2.5.4-5,.7-7.5,1.1v-21.2c-1.5,4.2-3,8.3-4.5,12.5-2.3.3-4.6.6-6.8.9-1.5-3.7-3-7.5-4.5-11.2v21.2c-2.5.3-5,.6-7.5.8v-34.6c3.1-.3,6.1-.7,9.3-1,2.1,5.2,4.1,10.4,6.1,15.5,2.1-5.7,4.2-11.4,6.2-17.2,3-.4,6-.8,9.2-1.4h-.1.1Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,98.7v5.9c2.7-.5,5.5-.9,8.2-1.5v6.4c-2.7.5-5.5,1-8.2,1.5v6.8c3.8-.6,7.6-1.4,11.4-2.1v7.8c-6.2,1.2-12.6,2.3-18.8,3.3v-34.6c6.2-1,12.6-2.2,18.8-3.3v7.8c-3.7.7-7.6,1.5-11.4,2.1h0v-.1Z",
    style: {
      fill: "#efe1bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.9,94.6v-2.6c-2.6.6-5.2,1.1-7.8,1.7v6.1c3-.6,6.1-1.4,9.2-2,3.3-.7,6,1.6,6,5v8c0,3.4-2.7,7-6,7.8-3.5.8-7,1.6-10.5,2.3-3.3.7-6-1.7-6-5.1v-4.1c2.5-.5,4.9-1,7.4-1.6v2.6c2.6-.5,5.2-1.1,7.8-1.7v-5.3c-3,.7-6.1,1.4-9.2,2-3.3.7-6-1.6-6-5.1v-8.8c0-3.4,2.7-6.9,6-7.6,3.5-.7,7-1.5,10.5-2.3,3.3-.7,6,1.6,6,5v4c-2.5.6-4.9,1.1-7.4,1.7Z",
    style: {
      fill: "#efe1bc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigaAppLfgLogo);
export default __webpack_public_path__ + "static/media/LIGA_APP_LFG_logo.c1d9b94ac55daacfdda93b8b0501db6d.svg";
export { ForwardRef as ReactComponent };